<div>
  <h4>Replication for this Blob Storage container needs to be configured.</h4>
</div>
<div class="margin-top">
  {{ uiService.productName }} will create a clone of this blob container in the recovery environment and optionally
  replicate its contents.
</div>
<form [formGroup]="configFormModel" (ngSubmit)="saveClick()" class="form-controls">
  <div>
    <div class="control-header-with-instructions">
      <h4 class="spacer">How should {{ uiService.productName }} recover this blob container?</h4>
    </div>
    <div class="arpio-radio-container">
      <label class="arpio-radio">
        <input id="object-replication-mode" type="radio" formControlName="objectReplicationMode" value="none" />
        <span class="radio-label strong-text">Recover the blob container but not its contents</span>
        <div>
          Choose this option for blob containers containing ephemeral data or data that is not relevant in the recovery
          environment (such as logs). A clone of this blob container will be created in the recovery environment but
          {{ uiService.productName }} will not manage its contents.
        </div>
      </label>
      <label class="arpio-radio">
        <input id="object-replication-mode" type="radio" formControlName="objectReplicationMode" value="realTime" />
        <span class="radio-label strong-text"> Recover the blob container and its contents </span>
        <div>
          Choose this option for blob containers containing persisted application data. A clone of this container will
          be created in the recovery environment and objects in this container will be replicated into the cloned
          container via <a target="_blank" href="{{ uiService.azureBlobReplicationUrl }}">block blob replication</a>.
        </div>
      </label>
      @if (objectReplicationMode == 'realTime') {
        <div class="flex-bottom-row">
          <div class="full-width">
            <div class="flex-center-row control-header-with-instructions">
              <h4 class="spacer">Objects To Backfill</h4>
              <h4>{{ backfillRangeText }}</h4>
            </div>
            <div class="control-header-instructions">
              Specify the timeframe of objects to backfill into this new blob container.
            </div>
            <input
              id="back-fill-range"
              class="full-width"
              type="range"
              min="0"
              [max]="backfillOptions.length - 1"
              formControlName="backfillRange"
            />
          </div>
        </div>
      }
    </div>
  </div>
  <div class="flex-center-row control-header">
    <div class="spacer"></div>
    <button type="submit" class="arpio-button" [disabled]="!validConfig">
      @switch (saveStatus) {
        @case ('saving') {
          <svg lucideLoaderCircle class="lucide-spin"></svg>
        }
        @case ('saved') {
          <svg lucideCheck></svg>
        }
        @default {
          Save
        }
      }
    </button>
  </div>
</form>
